import { isAfter, isValid, parse, startOfToday } from 'date-fns';
import { z } from 'zod';

const dateOfBirthSchema = z
  .string()
  .min(1, 'Please make a selection')
  .refine(
    (date) => {
      if (!date) return false;
      const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!datePattern.test(date)) return false;

      const parsedDate = parse(date, 'MM/dd/yyyy', new Date());
      return isValid(parsedDate);
    },
    { message: 'Please enter a valid date' }
  )
  .refine(
    (date) => {
      if (!date) return false;
      const parsedDate = parse(date, 'MM/dd/yyyy', new Date());

      if (!isValid(parsedDate)) return false;
      return !isAfter(parsedDate, startOfToday());
    },
    { message: 'Date cannot be in the future' }
  );

export const verificationSchema = z.object({
  last_name: z.string().min(1, 'Last name is required'),
  date_of_birth: dateOfBirthSchema,
});

export type VerificationFormData = z.infer<typeof verificationSchema>;
